import module from 'finanzas/module.js'
import template from './template.html'


export class FinancesPosicionbancariaSaldosComponent {
  fechaCorte
  estatusCuenta
  estatus = [
    {descripcion: 'TODAS'},
    {descripcion: 'ACTIVAS'},
    {descripcion: 'INACTIVAS'},
    {descripcion: 'SUSPENDIDAS'},
  ]

  constructor ($location) {
    this.$location = $location
  }

  $onChanges (changes) {
    if (changes.fechaCorte)
      this.fechaCorte = this.fechaCorte || new Date()
      this.estatusCuenta = this.estatusCuenta || 'ACTIVAS'
  }

  buscar () {
    this.$location.search({
      fecha_corte: this.fechaCorte && this.fechaCorte.toYMD(),
      estatus_cuenta: this.estatusCuenta && this.estatusCuenta,
    })
  }

}

// function FinancesPosicionbancariaSaldosComponent ($location) {
//   var $ctrl = this
//   $ctrl.$onChanges = $onChanges
//   $ctrl.buscar = buscar
//
//   function $onChanges (changes) {
//     if (changes.fechaCorte)
//       $ctrl.fechaCorte = $ctrl.fechaCorte || new Date()
//   }
//
//   function buscar () {
//     $location.search({
//       fecha_corte: $ctrl.fechaCorte && $ctrl.fechaCorte.toYMD(),
//     })
//   }
// }

module.component('financesPosicionbancariaSaldos', {
  controller: FinancesPosicionbancariaSaldosComponent,
  template,
  bindings: {
    fechaCorte: '<',
    estatusCuenta: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/saldos/component.js